<div class="d-flex flex-wrap timeline-card" style="row-gap: 10px" *ngIf="timeline.length">
  <ng-container *ngFor="let category of timeline">
    <ng-container *ngIf="category && !category.hideCategory">
      <div
        *ngFor="let milestone of category.items; first as isFirst; last as isLast"
        class="milestone-item"
        [ngClass]="{ 'disabled-milestone': milestone.activeMilestone === false }"
        [ngStyle]="{
          width: milestone.items ? `${milestone.items.length * 115}px` : '115px',
          'border-bottom': category.showToggleIcons ? `5px solid ${milestone.blockColor}` : 'none',
          'border-left': isFirst && category.showToggleIcons ? `4px solid ${milestone.blockColor}` : 'none',
          'border-right': isLast && category.showToggleIcons ? `4px solid ${milestone.blockColor}` : 'none',
          position: isFirst ? 'relative' : 'relative',
        }">
        <!-- Toggle category view arrows -->
        <div
          *ngIf="category.showToggleIcons && isFirst && !category.hideCategory"
          class="arrow-icon left-arrow"
          [ngStyle]="{ color: category.blockColor }"
          (click)="toggleCategory(category)"
          title="{{ 'collapse' | translate }}">
          <i class="right-icon fa fa-caret-right fa-lg"></i>
        </div>

        <div
          *ngIf="category.showToggleIcons && isLast && !category.hideCategory"
          class="arrow-icon right-arrow"
          [ngStyle]="{ color: category.blockColor }"
          (click)="toggleCategory(category)"
          title="{{ 'collapse' | translate }}">
          <i class="left-icon fa fa-caret-left fa-lg"></i>
        </div>

        <ng-container *ngIf="!milestone.items">
          <div
            class="milestone-header px-2"
            [class.gate-milestone]="gateMilestoneNames.includes(milestone.name)"
            [style.background-color]="milestone.blockColor"
            (click)="onMilestoneClick(milestone)">
            <div class="mad">{{ milestone?.mad === 'MAD' ? 'DUE DATE' : milestone?.mad }}</div>
            <div class="drive-date">{{ getFormattedDate(milestone.driveDate) | ngbDate }}</div>
          </div>
          <div
            class="milestone-body px-2"
            [ngClass]="{
              'milestone-delayed': milestone.status === 'DELAYED',
              'milestone-upcoming': milestone.status === 'UPCOMING_EXPIRY',
              'milestone-completed': milestone.status === 'COMPLETED',
              'milestone-in-progress': milestone.status === 'IN_PROGRESS',
              'milestone-border-right': !isLast,
            }"
            (click)="onMilestoneClick(milestone)">
            <!-- <img _ngcontent-grj-c405="" src="/assets/img/project-v2/calendar-black.svg" width="12" height="10" class="calendar-icon"> -->
            <div class="milestone-name">{{ milestone.name }}</div>
            <div class="actual-date"
              >{{ milestone.actualDate ? (getFormattedDate(milestone.actualDate) | ngbDate) : 'NA' }}
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="milestone.items">
          <div class="milestone-sub-item-container d-flex flex-row">
            <div
              *ngFor="let subItem of milestone.items"
              class="milestone-sub-item w-100"
              [ngClass]="{ 'disabled-milestone': subItem.activeMilestone === false }">
              <div class="milestone-sub-item-header" [style.background-color]="milestone.blockColor">
                <div class="mad">{{ subItem.mad }}</div>
                <div class="drive-date">{{ getFormattedDate(subItem.driveDate) | ngbDate }}</div>
              </div>
              <div
                class="subitem-body milestone-border-right"
                [ngClass]="{
                  'milestone-delayed': subItem.status === 'DELAYED',
                  'milestone-upcoming': subItem.status === 'UPCOMING_EXPIRY',
                  'milestone-completed': subItem.status === 'COMPLETED',
                  'milestone-in-progress': subItem.status === 'IN_PROGRESS',
                }"
                (click)="onMilestoneClick(subItem)">
                <div class="milestone-name">{{ subItem.name }}</div>
              </div>
            </div>
          </div>
          <div class="milestone-body-sub">
            <div class="milestone-name">{{ milestone.name }}</div>
          </div>
        </ng-container>
      </div>
    </ng-container>
    <ng-container *ngIf="category?.hideCategory">
      <div
        class="category-open-container d-flex flex-row"
        [ngStyle]="{ 'background-color': category.blockColor }"
        (click)="toggleCategory(category)"
        title="{{ 'expand' | translate }}">
        <img class="me-1" src="/assets/img/project-v2/right-triangle-white.svg" alt="" />
        <img src="/assets/img/project-v2/left-triangle-white.svg" alt="" />
      </div>
    </ng-container>
  </ng-container>
</div>
